// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"c3170b39","395":"b1f0c7bc","400":"401303cc","500":"b5777ae3"}[chunkId] + ".chunk.js";
};